import cn from 'classnames';

export const formBaseButtonBlockStyles = cn(
  'sticky bg-white bottom-0 pt-[40px] flex items-center gap-[10px]',
);
export const formFieldBaseStylesModal650 = cn(
  'grid',
  'grid-rows-1 grid-cols-[auto_350px]',
  'w-full',
  'items-baseline h-full ',
);
export const formBaseContainerStyles = cn('flex flex-col gap-[20px] p-[20px_0px_40px_0px]');
export const formFieldNameBaseStyles = cn(
  'text-1color text-[15px] font-[500] leading-[110%] tracking-tight',
);
